import { Tabs } from '@bfe/moly';
import React, { FC, useState } from 'react';
import cls from 'classnames';
import { Block } from '@/components/Layout';
// import Image from 'next/image'
import { useI18n } from '@spot-fe/base-ui';
import {
  howBuyTakerClick,
  howBuyMakerClick,
  howSellTakerClick,
  howSellMakerClick,
} from '@/config/sensor';
import styles from './index.module.scss';

import icon1 from '@/app/assets/icons/1.svg';
import icon2 from '@/app/assets/icons/2.svg';
import icon3 from '@/app/assets/icons/3.svg';
import icon4 from '@/app/assets/icons/4.svg';
import icon5 from '@/app/assets/icons/5.svg';
import icon6 from '@/app/assets/icons/6.svg';

export const Guide: FC = () => {
  const { t } = useI18n();
  const [activeKey, setActiveKey] = useState('1');

  const handleActiveChange = (newKey) => {
    const sensorMap = {
      1: howBuyMakerClick,
      2: howBuyTakerClick,
      3: howSellMakerClick,
      4: howSellTakerClick,
    };
    setActiveKey(newKey);
    sensorMap[newKey]?.();
  };

  const items = [
    {
      label: <h3>{t('buyAsMaker')}</h3>,
      key: '1',
    },
    {
      label: <h3>{t('buyAsTaker')}</h3>,
      key: '2',
    },
    {
      label: <h3>{t('sellAsMaker')}</h3>,
      key: '3',
    },
    {
      label: <h3>{t('sellAsTaker')}</h3>,
      key: '4',
    },
  ];

  const firstContent = {
    '1': t('createOrderBuy'),
    '2': t('findOrder'),
    '3': t('createSellOrder'),
    '4': t('findOrder'),
  };

  const secondContent = {
    '1': t('waitSellerMatch'),
    '2': t('acceptSellOrder'),
    '3': t('waitBuyerMatch'),
    '4': t('acceptBuyOrder'),
  };

  const thirdContent = {
    '1': t('receiveTokens'),
    '2': t('receiveTokens'),
    '3': t('deliverTokens'),
    '4': t('deliverTokens'),
  };

  const iconContentMap = [
    {
      '1': <img alt="" src={icon1.src} />,
      '2': <img alt="" src={icon4.src} />,
      '3': <img alt="" src={icon1.src} />,
      '4': <img alt="" src={icon4.src} />,
    },
    {
      '1': <img alt="" src={icon2.src} />,
      '2': <img alt="" src={icon5.src} />,
      '3': <img alt="" src={icon2.src} />,
      '4': <img alt="" src={icon5.src} />,
    },
    {
      '1': <img alt="" src={icon3.src} />,
      '2': <img alt="" src={icon3.src} />,
      '3': <img alt="" src={icon6.src} />,
      '4': <img alt="" src={icon6.src} />,
    },
  ];

  const body = (
    <div className={styles.step}>

      <div className={styles.item}>
        <div className={styles.icon}>
          {iconContentMap[0][activeKey]}
        </div>
        <div className={styles.desc}>{firstContent[activeKey]}</div>
      </div>
      <p className={styles.divs} />
      <div className={cls(styles.item)}>
        <div className={styles.icon}>
          {iconContentMap[1][activeKey]}
        </div>
        <div className={styles.desc}>{secondContent[activeKey]}</div>
      </div>
      <p className={styles.divs} />
      <div className={styles.item}>
        <div className={styles.icon}>
          {iconContentMap[2][activeKey]}
        </div>
        <div className={styles.desc}>{thirdContent[activeKey]}</div>
      </div>
    </div>
  );

  return (
    <Block bgColor="#000">
      <div className={styles.guide}>
        <div className={styles.headings}>
          <p className={styles.preLine} />
          <h2 className={styles.heading}>{t('tradePreMarket')}</h2>
        </div>
        <Tabs
          tabType="button"
          items={items}
          className={styles.tabs}
          activeKey={activeKey}
          onChange={handleActiveChange}
          showScrollButton
        />
        <div className={styles.content}>{body}</div>
      </div>
    </Block>
  );
};
